import { render, staticRenderFns } from "./DepositSchedule.vue?vue&type=template&id=5e63a8f4&"
import script from "./DepositSchedule.vue?vue&type=script&lang=js&"
export * from "./DepositSchedule.vue?vue&type=script&lang=js&"
import style0 from "./DepositSchedule.vue?vue&type=style&index=0&id=5e63a8f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports